module.exports = __webpack_public_path__ + "assets/img/mecha-btn-fdd3ae71.png";